export const fragenGewaehrleistungPrivatverkaufAuto = [
  {
    question: "Gilt die Gewährleistung auch bei „Bastlerfahrzeugen“?",
    answer: (
      <>
        <p>
          Ja, aber nur, wenn du keine eindeutige Bastlerklausel im Vertrag hast.
          Formulierungen wie „Fahrzeug wird als Bastlerauto ohne Gewährleistung
          verkauft“ schützen dich zusätzlich.
        </p>
      </>
    ),
  },
  {
    question: "Was passiert, wenn der Käufer nachträglich Mängel findet?",
    answer: (
      <>
        <p>
          Hat er unterschrieben, dass das Auto „wie besichtigt, unter Ausschluss
          der Gewährleistung“ verkauft wurde, kann er nur bei arglistiger
          Täuschung Ansprüche stellen.
        </p>
      </>
    ),
  },
  {
    question: "Wie lange gilt die Gewährleistung beim Privatverkauf?",
    answer: (
      <>
        <p>Standardmäßig 2 Jahre, außer sie wurde im Vertrag ausgeschlossen.</p>
      </>
    ),
  },
  {
    question: "Kann ich nachträglich noch die Gewährleistung ausschließen?",
    answer: (
      <>
        <p>Nein, der Ausschluss muss vor oder beim Vertragsabschluss erfolgen.</p>
      </>
    ),
  },
  {
    question: "Was, wenn ich mir unsicher bin, ob mein Auto Mängel hat?",
    answer: (
      <>
        <p>
          Dann ist ein Verkauf über Autoeinfachlos sinnvoll, hier prüfen Händler
          den Zustand und übernehmen die Haftung.
        </p>
      </>
    ),
  },
];
